import { url } from './url.js';

const bareSpecifier = "@vp/newrelic-browser-micro-agent/agent";
const importModule = () => {
  if (window._vpMicroAgentModule) {
    return window._vpMicroAgentModule;
  }
  if (window.System?.resolve(bareSpecifier)) {
    window._vpMicroAgentModule = window.System.import(bareSpecifier);
    return window._vpMicroAgentModule;
  }
  const srcUrl = url(window.location.hostname);
  window._vpMicroAgentModule = dynamicImport(srcUrl).catch((error) => {
    console.error("MicroAgent failed to load", {
      url: srcUrl,
      error: error.message
    });
    window._vpMicroAgentModule = void 0;
    throw error;
  });
  return window._vpMicroAgentModule;
};
function dynamicImport(moduleUrl) {
  const agentRegister = window.__vpMicroAgentRegister;
  if (agentRegister?.module) {
    return Promise.resolve(agentRegister.module);
  }
  if (agentRegister?.pending) {
    return agentRegister.pending;
  }
  let resolvePromise;
  let rejectPromise;
  const loadingPromise = new Promise((resolve, reject) => {
    resolvePromise = resolve;
    rejectPromise = reject;
  });
  if (window.__vpMicroAgentRegister) {
    window.__vpMicroAgentRegister.pending = loadingPromise;
  }
  const script = document.createElement("script");
  script.type = "module";
  script.src = moduleUrl;
  script.onerror = (err, x) => {
    console.error("Error loading module script:", err, x);
    if (window.__vpMicroAgentRegister) {
      window.__vpMicroAgentRegister.pending = void 0;
    }
    rejectPromise(new Error(`Failed to load module script: ${moduleUrl}`));
  };
  script.onload = () => {
    const currentRegister = window.__vpMicroAgentRegister;
    if (currentRegister?.module) {
      currentRegister.pending = void 0;
      resolvePromise(currentRegister.module);
    } else {
      if (currentRegister) {
        currentRegister.pending = void 0;
      }
      rejectPromise(new Error(`Module ${moduleUrl} loaded but did not register itself.`));
    }
    script.remove();
  };
  document.head.appendChild(script);
  return loadingPromise;
}

export { importModule };
